<template>
    <div>
        <label v-if="label" class="mb-2 inline-block">{{ label }}:</label>
        <div class="bg-white sm:w-1/2">
            <canvas ref="canvas" class="signature-canvas w-full h-56 border"></canvas>
        </div>
      <div v-if="dataError" class="text-red-500 text-sm mt-2">{{ dataError }}</div>
    </div>
</template>

<script>
    import SignaturePad from 'signature_pad';

    export default {
        props: {
            value: null,
            label: String,
            dataError: String,
        },
        data() {
            return {
                signaturePad: null,
            }
        },
        mounted() {
            let self = this;

            this.signaturePad = new SignaturePad(this.$refs.canvas, {
                backgroundColor: 'rgb(255, 255, 255)',
                onEnd() {
                    self.$emit('input', this.toDataURL('image/png'));
                }
            });

            window.onresize = this.resizeCanvas();
            this.resizeCanvas();
        },

        methods: {
            clear() {
                this.signaturePad.clear();
            },
            resizeCanvas() {
                // When zoomed out to less than 100%, for some very strange reason,
                // some browsers report devicePixelRatio as less than 1
                // and only part of the canvas is cleared then.
                let ratio = Math.max(window.devicePixelRatio || 1, 1);
                let canvas = this.$refs.canvas;
                canvas.width = canvas.offsetWidth * ratio;
                canvas.height = canvas.offsetHeight * ratio;
                canvas.getContext("2d").scale(ratio, ratio);
            }
        }
    }
</script>
